import { useEffect, useState } from 'react'
import { backendRequest, backendRequestAndNotification, createNotification } from '../api'
import { faGem } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import YouTubePlayer from './rickroll'

const ExclusiveModal = ({ user, setShow }) => {

    const [tasks, setTasks] = useState([])
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        getTasks()
    }, [])

    const getTasks = async () => {
        try {
            setLoading(true)
            const res = await backendRequest('/tasks/all', 'GET')
            if (res.type === 'success') {
                setTasks(res.tasks || [])
            } else {
                setTasks([])
            }
        } catch (e) {
            console.error('Error fetching tasks:', e)
            setTasks([])
        } finally {
            setLoading(false)
        }
    }

    const handleOffer = (e) => {
        const offerElement = e.target.closest('.exclusive-offer') || e.target.closest('.exclusive-offer-extended');
        if (!offerElement) return;

        const trackingId = user?.offer_id;

        if (offerElement.id === 'rustclash') {
            const newWindow = window.open(`https://trk.rustclash.com/click?o=3&a=119&c=90&sub_id1=${trackingId}`, '_blank', 'noopener,noreferrer');
            if (newWindow) newWindow.opener = null;
        }

        if (offerElement.id === 'casesgg') {
            const newWindow = window.open(`https://trk.cases.gg/click?o=1&a=119&c=88&sub_id1=${trackingId}`, '_blank', 'noopener,noreferrer');
            if (newWindow) newWindow.opener = null;
        }

        if (offerElement.id === 'clash') {
            const newWindow = window.open(`https://trk.clash.gg/click?o=2&a=119&c=89&sub_id1=${trackingId}`, '_blank', 'noopener,noreferrer');
            if (newWindow) newWindow.opener = null;
        }

        if (offerElement.id === 'arbor') {
            const newWindow = window.open(`https://www.joinarbor.com/?utm_source=grindbux&utm_medium=partner&utm_campaign=grindbux&affiliate=grindbux&transaction_id=${trackingId}`, '_blank', 'noopener,noreferrer');
            if (newWindow) newWindow.opener = null;
        }
    }

    const handleTaskClick = (task) => {
        const url = task.url.replace('{userId}', user?.offer_id);
        const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
        if (newWindow) newWindow.opener = null;
    }

    // Filter tasks by user's country
    const availableTasks = tasks.filter(task => {
        if (!task.countries || task.countries.length === 0) return true; // Show if no geo restrictions
        return task.countries.includes(user?.country);
    });

    // Check if user qualifies for Arbor offer
    const hasArborOffer = user?.country === 'US';

    // Check if there are any offers available
    const hasAnyOffers = hasArborOffer || availableTasks.length > 0;

    return (
        <>
            <div className='exclusive-modal' onClick={(e) => { setShow(false) }}>
                <div className='exclusive-container' onClick={(e) => e.stopPropagation()}>
                    <p className='close' onClick={(e) => { setShow(false) }}>x</p>

                    <p className='title gold'>GrindBux Exclusive</p>

                    {/* Static Arbor offer for US users */}
                    {hasArborOffer && (
                        <div id='arbor' className='exclusive-offer-extended' onClick={handleOffer}>
                            <div className='offer-image'>
                                <img src="/offers/arbor.png" alt="exclusive" />
                            </div>

                            <div className='offer-content'>
                                <div className='offer-header'>
                                    <h3 className='title'>Join Arbor</h3>
                                    <div className='reward'>17500 <FontAwesomeIcon icon={faGem} /></div>
                                </div>

                                <p className='description'>
                                    In eligible states, receive your reward when you link your utility account
                                    with valid information to see your potential electricity bill savings.
                                    It's free with no commitments.
                                </p>

                                <ul className='steps-list'>
                                    <li>Create an Arbor account</li>
                                    <li>Link your utility account to Arbor</li>
                                    <li>See how much you can save and get your reward</li>
                                </ul>
                            </div>
                        </div>
                    )}

                    {/* Dynamic tasks filtered by user's country */}
                    {loading ? (
                        <p>Loading tasks...</p>
                    ) : (
                        availableTasks.map((task) => (
                            <div
                                key={task.taskId}
                                className='exclusive-offer-extended'
                                onClick={() => handleTaskClick(task)}
                            >
                                <div className='offer-image'>
                                    <img src={task.image || "/offers/default.png"} alt={task.name} />
                                </div>

                                <div className='offer-content'>
                                    <div className='offer-header'>
                                        <h3 className='title'>{task.name}</h3>
                                        <div className='reward'>
                                            {task.reward.toLocaleString()} <FontAwesomeIcon icon={faGem} />
                                        </div>
                                    </div>

                                    {task.instructions && (
                                        <p className='instructions'>{task.instructions}</p>
                                    )}

                                    {task.steps && task.steps.length > 0 && (
                                        <ul className='steps-list'>
                                            {task.steps.map((step, index) => (
                                                <li key={step.id || index}>
                                                    <span className='step-description'>{step.description}</span>
                                                    {step.reward > 0 && (
                                                        <span className='step-reward'>
                                                            {step.reward.toLocaleString()} <FontAwesomeIcon icon={faGem} />
                                                        </span>
                                                    )}
                                                </li>
                                            ))}
                                        </ul>
                                    )}

                                    {task.description && (
                                        <p className='instructions'>{task.description}</p>
                                    )}
                                </div>
                            </div>
                        ))
                    )}

                    {/* Show "no offers" message only when there are truly no offers */}
                    {!loading && !hasAnyOffers && (
                        <p>There are no exclusive offers available for your region right now</p>
                    )}

                    {/* <div id='rustclash' className='exclusive-offer' onClick={handleOffer}>
                        <div className='exclusive-left'>
                            <img src="/offers/rustclash.png" alt="exclusive" />
                            <div className='exclusive-left-text'>
                                <p className='title'>RustClash</p>
                                <p className='description'>Create a new account and deposit $5 USD</p>
                            </div>
                        </div>

                        <div className='exclusive-right'>
                            <div className='reward'>7000 <FontAwesomeIcon icon={faGem}/></div>
                        </div>
                    </div>

                    <div id='casesgg' className='exclusive-offer' onClick={handleOffer}>
                        <div className='exclusive-left'>
                            <img src="/offers/casesgg.png" alt="exclusive" />
                            <div className='exclusive-left-text'>
                                <p className='title'>CasesGG</p>
                                <p className='description'>Create a new account and deposit $5 USD</p>
                            </div>
                        </div>

                        <div className='exclusive-right'>
                            <div className='reward'>7000 <FontAwesomeIcon icon={faGem}/></div>
                        </div>
                    </div>

                    <div id='clash' className='exclusive-offer' onClick={handleOffer}>
                        <div className='exclusive-left'>
                            <img src="/offers/clash.png" alt="exclusive" />
                            <div className='exclusive-left-text'>
                                <p className='title'>ClashGG</p>
                                <p className='description'>Create a new account and deposit $5 USD</p>
                            </div>
                        </div>

                        <div className='exclusive-right'>
                            <div className='reward'>7000 <FontAwesomeIcon icon={faGem}/></div>
                        </div>
                    </div> */}
                </div>
            </div>

            <style jsx>
                {`
                    .exclusive-modal {
                        position: fixed;
                        height: 100%;
                        width: 100%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        background: rgba(0,0,0,0.3);
                        z-index: 1001;
                        top: 0;
                        left: 0;
                    }

                    .title {
                        font-size: 16px;
                        font-weight: 500;
                    }

                    .gold {
                        color: #F1C475;
                    }

                    .exclusive-container {
                        position: relative;
                        height: fit-content;
                        width: 700px;
                        max-height: 90vh;
                        background: #21294D;
                        border-radius: 8px;

                        display: flex;
                        flex-direction: column;

                        padding: 24px;
                        box-sizing: border-box;
                        gap: 12px;

                        /* Add scrolling with hidden scrollbar */
                        overflow-y: auto;
                        overflow-x: hidden;
                        
                        /* Hide scrollbar for webkit browsers (Chrome, Safari, Edge) */
                        scrollbar-width: none; /* Firefox */
                        -ms-overflow-style: none; /* Internet Explorer 10+ */
                    }

                    /* Hide scrollbar for webkit browsers */
                    .exclusive-container::-webkit-scrollbar {
                        display: none;
                    }

                    .close {
                        font-weight: 700;
                        font-size: 12px;
                        position: absolute;
                        top: 8px;
                        right: 8px;
                        cursor: pointer;
                    }


                    .exclusive-offer {
                        padding: 6px 8px;
                        border-radius: 4px;
                        background-color: #2A335B;

                        display: flex;
                        align-items: center;
                        justify-content: space-between;

                        cursor: pointer;
                    }

                    .exclusive-left {
                        display: flex;
                        align-items: center;
                        gap: 8px;
                    }
                    
                    .exclusive-left-text .description {
                        font-size: 14px;
                        color: #999;
                    }

                    .exclusive-left-text .title {
                        font-size: 16px;
                        font-weight: 600;
                    }

                    .exclusive-left img {
                        height: 5rem;
                        width: 5rem;
                        border-radius: 4px;
                    }

                    .exclusive-right .reward {
                        font-size: 14px;
                        font-weight: 600;
                        color: #F1C475;
                        padding: 4px 8px;
                        background-color: #4D3A4B;
                        border-radius: 4px;
                    }

                    p {
                        margin: unset;
                    }

                    .exclusive-offer-extended {
                        padding: 10px 10px;
                        border-radius: 4px;
                        background-color: #2A335B;
                        cursor: pointer;
                        display: grid;
                        grid-template-columns: auto 1fr;
                        gap: 10px;
                    }

                    .offer-image img {
                        height: 5rem;
                        width: 5rem;
                        border-radius: 4px;
                    }

                    .offer-content {
                        display: flex;
                        flex-direction: column;
                        gap: 10px;
                    }

                    .offer-header {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                    }

                    .offer-header .title {
                        font-size: 16px;
                        font-weight: 600;
                        margin: 0;
                    }

                    .description {
                        font-size: 14px;
                        color: #999;
                        line-height: 1.3;
                        margin: 0;
                    }

                    .instructions {
                        font-size: 14px;
                        color: #fff;
                        line-height: 1.3;
                        margin: 0;
                    }

                    .steps-list {
                        list-style: none;
                        padding: 0;
                        margin: 0;
                    }

                    .steps-list li {
                        color: #999;
                        font-size: 14px;
                        line-height: 1.6;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        padding: 4px 0;
                        border-bottom: 1px solid rgba(255, 255, 255, 0.05);
                    }

                    .steps-list li:last-child {
                        border-bottom: none;
                    }

                    .step-description {
                        flex: 1;
                    }

                    .step-reward {
                        color: #F1C475;
                        font-weight: 600;
                        font-size: 13px;
                        background-color: rgba(241, 196, 117, 0.1);
                        padding: 2px 6px;
                        border-radius: 4px;
                        display: flex;
                        align-items: center;
                        gap: 3px;
                        white-space: nowrap;
                    }

                    .reward {
                        font-size: 14px;
                        font-weight: 600;
                        color: #F1C475;
                        padding: 4px 8px;
                        background-color: #4D3A4B;
                        border-radius: 4px;
                    }
                `}
            </style>
        </>
    )
}

export default ExclusiveModal